<template>
	<div class="person_box animate__animated animate__fadeIn">
		<div class="person">
			<div class="search_box">
				<div class="box_line">
					<div class="line_input">
						<div class="input_title">考试题目</div>
						<input type="text" class="input_box" placeholder="请输入考试题目" v-model="searchTitle" />
					</div>
					<div class="line_input">
						<div class="input_title">题目类型</div>
						<el-select size="small" class="select_box" v-model="searchType" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
							<el-option label="请选择" value></el-option>
							<el-option label="单选题" value="1">单项选择题</el-option>
							<el-option label="多选题" value="2">多项选择题</el-option>
							<el-option label="判断题" value="3">判断题</el-option>
						</el-select>
					</div>
					<div class="line_input">
						<div class="input_title">创建时间</div>
						<el-date-picker
							size="small"
							v-model="searchCreateAt"
							type="datetimerange"
							value-format="yyyy-MM-dd HH:mm:ss"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							style="width: 392px;"
						></el-date-picker>
					</div>
					<div class="search_btn" @click="fnSearch"><span>搜索</span></div>
				</div>
				<div class="box_line title">
					<div class="text">题库列表</div>
					<div class="search_btn" @click="fnOpenAddOrEdit('add')"><span>新增试题</span></div>
					<div class="search_btn right" @click="fnOpenOtherTest"><span>其他题库选题</span></div>
				</div>
			</div>
			<div class="cont_list all_list">
				<div class="list_box">
					<div v-if="tableData && tableData.length > 0">
						<div class="test_box" v-for="(item, index) in tableData" :key="index">
							<el-button @click="fnDelList(item)" style="float:right;margin-top:-25px" type="danger" icon="el-icon-delete" circle></el-button>
							<el-button @click="fnOpenAddOrEdit(item)" style="float:right;margin: -25px 20px 0 20px;" type="success" icon="el-icon-edit" circle></el-button>
							<div class="create_time">{{ item.create_at }}</div>
							<div class="box_title">
								<div class="title_txt">【{{ item.type }}】【{{ item.score }} 分】{{ parseInt(index) + 1 }}、{{ item.title }}</div>
								<img v-if="item.imgs" :src="item.imgs" />
							</div>
							<div class="box_answer">
								<div class="answer" v-for="(opt, idx) in item.answer" :key="idx">
									<div class="answer_txt" v-if="opt.answer_type == 't'">{{ fnChangeIndex(idx) }}、{{ opt.answer_text }}</div>
									<div class="answer_img" v-else>
										{{ fnChangeIndex(idx) }}、
										<img :src="opt.answer_text" />
									</div>
								</div>
								<div class="right_answer">【正确答案】{{ fnChangeAnswer(item.right_answer) }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cont_page">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="pageSizes"
					:page-size="pageSize"
					:current-page="currentPage"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pageTotal"
				/>
			</div>
			<!-- 新增考试试题 -->
			<div class="dialog_test" v-if="showAddTest">
				<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="新增/编辑试题" top="20vh" center :visible.sync="showAddTest">
					<div class="test_boxes">
						<div class="test_cont">
							<div class="test_item">
								<div class="item_title">试题名称</div>
								<div class="item_text">
									<input type="text" class="input_box" placeholder="请输入试题名称" v-model="form.title" />
								</div>
							</div>
							<div class="test_item">
								<div class="item_title">试题图片</div>
								<div class="item_imgs">
									<el-upload
										class="avatar-uploader"
										action=""
										list-type="picture-card"
										:before-upload="
											res => {
												beforeCardPicUpload(res, 'photo');
											}
										"
										:show-file-list="false"
									>
										<img v-if="form.imgs" :src="form.imgs" class="avatar" />
										<i v-else class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
									<div class="search-btn" @click="fnClearImg('photo')"><span>清空图片</span></div>
								</div>
							</div>
							<div class="test_item">
								<div class="item_title">试题类型</div>
								<div class="item_text select">
									<el-select size="small" class="select_box" v-model="form.type" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
										<el-option label="请选择" value></el-option>
										<el-option label="单项选择题" value="1">单项选择题</el-option>
										<el-option label="多项选择题" value="2">多项选择题</el-option>
										<el-option label="判断题" value="3">判断题</el-option>
									</el-select>
								</div>
							</div>
							<div class="test_item">
								<div class="item_title">试题分数</div>
								<div class="item_text select">
									<el-select size="small" class="select_box" v-model="form.score" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
										<el-option label="请选择" value></el-option>
										<el-option label="1分" value="1">1分</el-option>
										<el-option label="2分" value="2">2分</el-option>
										<el-option label="3分" value="3">3分</el-option>
										<el-option label="5分" value="5">5分</el-option>
										<el-option label="10分" value="10">10分</el-option>
									</el-select>
								</div>
							</div>
							<div class="test_item">
								<div class="item_title">是否共享</div>
								<div class="item_text no-bg">
									<el-radio-group v-model="form.is_visible">
										<el-radio label="1">共享</el-radio>
										<el-radio label="0">不共享</el-radio>
									</el-radio-group>
								</div>
							</div>
							<div class="test_item">
								<div class="item_title">答案类型</div>
								<div class="item_text no-bg">
									<el-radio-group v-model="answerType" @change="fnAnswerTypeChange">
										<el-radio label="t">文字</el-radio>
										<el-radio label="i">图片</el-radio>
									</el-radio-group>
								</div>
							</div>
							<div class="test_item" v-if="rightAnswerList.length>0">
								<div class="item_title">正确答案</div>
								<div class="item_text no-bg">
									<el-checkbox-group v-model="rightAnswer" @change="handleCheckedAnswerChange">
										<el-checkbox v-for="(item,index) in rightAnswerList" :label="index" :key="index">{{item}}</el-checkbox>
									</el-checkbox-group>
								</div>
							</div>
							<div v-if="answerType=='t'">
								<div class="test_item" v-for="(item,index) in answerList" :key="index">
									<div class="item_title">试题答案{{ parseInt(index)+1 }}</div>
									<div class="item_text">
										<input type="text" class="input_box" placeholder="请输入答案" v-model="item.text" />
									</div>
								</div>
							</div>
							<div v-else>
								<div class="test_item" v-for="(item,index) in answerList" :key="index">									<div class="item_title">试题答案{{ parseInt(index)+1 }}</div>									<div class="item_imgs">										<el-upload											class="avatar-uploader"											action=""											list-type="picture-card"											:before-upload="												res => {													beforeCardPicUpload(res, 'answer',index);												}											"											:show-file-list="false"										>											<img v-if="item.text" :src="item.text" class="avatar" />											<i v-else class="el-icon-plus avatar-uploader-icon"></i>										</el-upload>
										<div class="search-btn" @click="fnClearImg('answer',index)"><span>清空图片</span></div>									</div>								</div>
							</div>
							<div class="test_item">
								<div class="search-btn" @click="fnAddTestAnswer"><span>新增试题答案</span></div>
							</div>
						</div>
					</div>
					<div slot="footer" class="dialog-footer" align="center">
						<div class="btn_line">
							<div class="search-btn red" @click="showAddTest = false"><span>取消</span></div>
							<div class="search-btn" @click="fnSaveAddOrEdit"><span>保存</span></div>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 其他项目题库 -->
			<div class="dialog_exam_other" v-if="showOtherTest">
				<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="其他项目题库" center :visible.sync="showOtherTest">
					<div class="exam_box">
						<div class="box_cont">
							<div class="mine_box">
								<div class="search_box mine_search">
									<div class="box_line mine_line">
										<div class="line_input">
											<div class="input_title">考试题目</div>
											<input type="text" class="input_box" placeholder="请输入考试题目" v-model="searchOtherTitle" />
										</div>
										<div class="line_input">
											<div class="input_title">题目类型</div>
											<el-select size="small" class="select_box" v-model="searchOtherType" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
												<el-option label="请选择" value></el-option>
												<el-option label="单项选择题" value="1">单项选择题</el-option>
												<el-option label="多项选择题" value="2">多项选择题</el-option>
												<el-option label="判断题" value="3">判断题</el-option>
											</el-select>
										</div>
									</div>
									<div class="box_line mine_line">
										<div class="line_input">
											<div class="input_title">创建时间</div>
											<el-date-picker
												size="small"
												v-model="searchOtherCreateAt"
												type="datetimerange"
												value-format="yyyy-MM-dd HH:mm:ss"
												range-separator="至"
												start-placeholder="开始日期"
												end-placeholder="结束日期"
												style="width: 392px;"
											></el-date-picker>
										</div>
										<div class="search-btn" @click="fnSearchOtherQuestionList"><span>搜索</span></div>
									</div>
								</div>
								<div class="cont_list">
									<div class="list_title">
										<div class="title_item">选择</div>
										<div class="title_item">题目名称</div>
										<div class="title_item">题目类型</div>
										<div class="title_item">创建时间</div>
										<div class="title_item">所属项目</div>
									</div>
									<div class="list_boxes_cont">
										<div class="list_box_cont">
											<div v-if="otherTkList && otherTkList.length > 0">
												<div class="box_line" v-for="(item, index) in otherTkList" :key="index">
													<div class="list_item"><div class="select" @click="fnHandleCheckedOtherTkChange(index, item)" :class="item.selected ? 'active' : ''"></div></div>
													<div class="list_item" :title="item.title">{{ item.title }}</div>
													<div class="list_item">{{ item.type }}</div>
													<div class="list_item">{{ item.create_at }}</div>
													<div class="list_item" :title="item.from_name">{{ item.from_name }}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="tips">注意：每次只能选择一道题！</div>
								<div class="other_page">
									<el-pagination
										background
										class="pagination"
										@size-change="handleOtherSizeChange"
										@current-change="handleOtherCurrentChange"
										:page-sizes="otherPageSizes"
										:page-size="otherPageSize"
										:current-page="otherCurrentPage"
										layout="total, sizes, prev, pager, next, jumper"
										:total="otherPageTotal"
									/>
								</div>
							</div>
						</div>
					</div>
					<div slot="footer" class="dialog-footer">
						<div class="btn_line">
							<div class="search-btn red" @click="showOtherTest = false"><span>取消</span></div>
							<div class="search-btn" @click="fnSaveOtherTest"><span>保存</span></div>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
import APP from '@/utils/base';
import request from '@/utils/request';
import { fnUpload } from '@/utils/upload';
import * as imageConversion from 'image-conversion';
export default {
	data() {
		return {
			// 其他项目试题弹窗
			otherPageSize: APP.PAGE.LIMIT,
			otherPageSizes: APP.PAGE.SIZE_OPTION,
			otherCurrentPage: APP.PAGE.SKIP_PAGE,
			otherPageTotal: 0,
			showOtherTest: false, // 其他项目题库弹窗
			otherTkList: [], // 其他项目题库试题列表
			otherTkListAll: [], // 其他项目题库试题列表 固定
			searchOtherTitle: '', // 自有题库考试题目搜索
			searchOtherType: '', // 自有题库考试类型搜索
			searchOtherCreateAt: '', // 自有题库创建时间搜索
			searchOtherTime: '', // 自有题库创建时间 - 格式化
			otherSelect: null,// 选择的其他项目试题
			// 页面列表
			// 分页
			pageSize: APP.PAGE.LIMIT,
			pageSizes: APP.PAGE.SIZE_OPTION,
			currentPage: APP.PAGE.SKIP_PAGE,
			pageTotal: 0,
			// 搜索
			searchTitle: '', // 试题题目搜索
			searchType: '', // 试题类型搜索
			searchCreateAt: '', // 试题创建时间
			searchTime: '',
			// 培训列表
			tableData: [], // 培训列表数据
			// 弹窗
			showAddTest: false,// 新增试题弹窗
			formLabelWidth: '120px', // 弹窗label宽度
			// 新增试题
			form:{
				title: '',// 试题题目
				imgs: '',// 题目里的图片
				type: '',// 考试类型
				answer: '',// 试题全部答案
				score: '',// 试题分数
				right_answer: '',// 试题正确答案
				is_visible: '0',// 是否共享
			},
			answerType: 't',//t->答案是文字类型 i->答案是图片类型
			answerForm:{
				text: ''
			},
			answerList: [],
			rightAnswerList: [],
			rightAnswer: []
		};
	},
	created() {
		this.fnInit();
		this.fnSearchOtherQuestionList()
	},
	methods: {
		// 初始化
		fnInit() {
			this.fnGetTestList(
				{
					page: this.currentPage,
					size: this.pageSize,
				},
				res => {
					let _data = res.data.query;
					if (_data.length > 0) {
						for(let i in _data){
							let _answer = _data[i].answer?JSON.parse(_data[i].answer):[]
							let _answerList = []
							for(let j in _answer){
								let _ob = {
									answer_type : _answer[j].split('|')[0],
									answer_text : _answer[j].split('|')[1]
								}
								_answerList.push(_ob)
							}
							_data[i].answer = _answerList
						}
						this.tableData = _data;
					}else{
						this.tableData = []
						this.$message.warning("暂无数据");
					}
					this.pageTotal = res.data.count;
				}
			);
		},
		// 转换数字标签为字母
		fnChangeIndex(index) {
			switch (parseInt(index)) {
				case 0:
					return 'A';
				case 1:
					return 'B';
				case 2:
					return 'C';
				case 3:
					return 'D';
				case 4:
					return 'E';
				default:
					break;
			}
		},
		// 正确答案格式化
		fnChangeAnswer(answer) {
			let _answer = answer.split(',');
			let _arr = [];
			for (let i in _answer) {
				_arr.push(this.fnChangeIndex(_answer[i]));
			}
			return _arr.join(',');
		},
		// 分页选择
		handleSizeChange(val) {
			this.pageSize = val;
			this.fnSearch();
		},
		// 分页跳转
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fnSearch();
		},
		// 获取考试试题列表
		fnGetTestList(_obj, _cb) {
			request({
				url: 'exam/question/lists',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					_cb && _cb(res);
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 搜索考试试题列表
		fnSearch(_isInit) {
			if (this.searchCreateAt) {
				this.searchTime = this.searchCreateAt[0] + ',' + this.searchCreateAt[1];
			} else {
				this.searchTime = '';
			}
			this.fnGetTestList(
				{
					page: _isInit ? 1 : this.currentPage,
					size: this.pageSize,
					title: this.searchTitle,
					type: this.searchType,
					create_at: this.searchTime,
				},
				res => {
					let _data = res.data.query;
					if (_data.length > 0) {
						for(let i in _data){
							let _answer = _data[i].answer?JSON.parse(_data[i].answer):[]
							let _answerList = []
							for(let j in _answer){
								let _ob = {
									answer_type : _answer[j].split('|')[0],
									answer_text : _answer[j].split('|')[1]
								}
								_answerList.push(_ob)
							}
							_data[i].answer = _answerList
						}
						this.tableData = _data;
					}else{
						this.tableData = []
						this.$message.warning("暂无数据");
					}
					this.pageTotal = res.data.count;
				}
			);
		},
		// 删除试题
		fnDelList(_data) {
			request({
				url: 'exam/question/del',
				method: 'POST',
				data: {
					id: _data.id
				}
			})
				.then(res => {
					this.$message.success(res.data);
					this.fnInit();
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 清空上传的图片
		fnClearImg(type,index){
			if(type == 'photo'){
				this.form.imgs = ''
			}else{
				this.answerList[index].text = ''
			}
		},
		// 打开新增/编辑试题弹窗
		fnOpenAddOrEdit(item){
			if(item == 'add'){
				this.form.title = ''
				this.form.imgs = ''
				this.form.type = ''
				this.form.answer = ''
				this.form.score = ''
				this.form.right_answer = ''
				this.answerList = []
				this.rightAnswerList = []
				this.answerType = 't'
				this.showAddTest = true
			}else{
				this.form.id = item.id
				this.form.title = item.title
				this.form.type = item.type =='单项选择题'?'1':item.type=='多项选择题'?'2':'3'
				this.form.imgs = item.imgs
				this.form.is_visible = ''+item.is_visible
				this.form.score = ''+item.score
				let _answer = item.answer
				let _answerList = []
				let _rightAnswerList = []
				let _answerType = ''
				for(let i in _answer){
					_answerType = _answer[i].answer_type
					let _obj = {
						text: _answer[i].answer_text
					}
					_answerList.push(_obj)
					_rightAnswerList.push('答案'+(parseInt(i)+1))
				}
				this.answerList = _answerList
				this.rightAnswerList = _rightAnswerList
				this.form.right_answer = ''
				this.rightAnswer = item.right_answer.split(',')
				for(let j in this.rightAnswer){
					this.rightAnswer[j] = parseInt(this.rightAnswer[j])
				}
				this.showAddTest = true
			}
		},
		// 上传图片
		beforeCardPicUpload(_file, _el, _index) {
			let that = this;
			// 把图片文件压缩到200kb
			imageConversion.compressAccurately(_file, 200).then(_res => {
				let reader = new FileReader();
				reader.onload = function() {
					let _base64 = this.result;
					// base64转文件流对象
					let _fileObject = APP.fnBase64ToFile(_base64);
					let formData = new FormData();
					formData.append('file', _fileObject);
					formData.append('type', 'image');
					if (_base64.indexOf('data:image/') != -1) {
						_base64 = _base64.split(',')[1];
					}
					fnUpload(formData, res => {
						if(_el == 'photo'){
							that.form.imgs = res.data.file_url
						}else{
							that.answerList[_index].text = res.data.file_url
						}
					});
				};
				reader.readAsDataURL(_res);
			});
			return false; // 阻止组件自动上传图片
		},
		// 答案类型改变
		fnAnswerTypeChange(e){
			this.answerType = e
			this.answerList = []
			this.rightAnswerList = []
			this.rightAnswer = []
		},
		// 选择切换正确答案
		handleCheckedAnswerChange(value){
			this.rightAnswer = value
		},
		// 新增考试答案
		fnAddTestAnswer(){
			let _obj = JSON.parse(JSON.stringify(this.answerForm))
			this.answerList.push(_obj)
			let _index = this.answerList.length
			this.rightAnswerList.push('答案'+_index)
		},
		// 保存 新增/编辑 试题
		fnSaveAddOrEdit(){
			if(this.form.title==''){
				this.$message.warning('您的试题名称不能为空!')
				return
			}
			if(this.form.type == ''){
				this.$message.warning('您的试题类型不能为空!')
				return
			}
			if(this.form.score == ''){
				this.$message.warning('请选择您的试题分数!')
				return
			}
			let _type = this.answerType + '|'
			let _arr = []
			if(this.answerList.length>0){
				for(let i in this.answerList){
					if(this.answerList[i].text == ''){
						this.$message.warning('请输入试题答案' + (parseInt(i)+1) + '的内容')
						return
					}else{
						_arr.push(_type + this.answerList[i].text)
					}
				}
				this.form.answer = JSON.stringify(_arr)
			}else{
				this.$message.warning('请新增试题答案!')
				return
			}
			if(this.rightAnswer.length>0){
				if(this.form.type == 1||this.form.type == 3){
					if(this.rightAnswer.length>1){
						this.$message.warning('您的试题只能选择一个正确答案!')
						return
					}
				}
				this.form.right_answer = this.rightAnswer.join(',')
			}else{
				this.$message.warning('请勾选您试题的正确答案!')
				return
			}
			let _url = 'exam/question/add'
			if(this.form.id){
				_url = 'exam/question/edit'
			}
			request({
				url: _url,
				method: 'POST',
				data: this.form
			})
				.then(res => {
					if(res.code == 1){
						this.$message.success(res.data)
						this.fnInit()
					}else{
						this.$message.error(res.data)
					}
					this.showAddTest = false
				})
				.catch(err => {
					this.$message.error(err.data);
				});

		},
		// 分页选择 其他项目考试试题
		handleOtherSizeChange(val) {
			this.otherPageSize = val;
			this.fnSearchOtherQuestionList();
		},
		// 分页跳转 其他项目考试试题
		handleOtherCurrentChange(val) {
			this.otherCurrentPage = val;
			this.fnSearchOtherQuestionList();
		},
		// 获取其他项目考试试题列表
		fnGetOtherQuestionList() {
			let _obj = {
				page: this.otherCurrentPage,
				size: this.otherPageSize
			};
			request({
				url: 'exam/question/otherLists',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					let _data = res.data.query;
					this.otherTkList = [];
					this.otherTkListAll = [];
					if (_data.length > 0) {
						for (let i in _data) {
							_data[i].selected = false;
						}
						this.otherTkList = _data;
						this.otherTkListAll = _data
					} else {
						this.$message.warning('暂无其他项目考试试题数据');
					}
					this.otherPageTotal = res.data.count;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 搜索其他项目考试试题列表
		fnSearchOtherQuestionList(_isInit) {
			if (this.searchOtherCreateAt) {
				this.searchOtherTime = this.searchOtherCreateAt[0] + ',' + this.searchOtherCreateAt[1];
			} else {
				this.searchOtherTime = '';
			}
			let _obj = {
				page: _isInit ? 1 : this.otherCurrentPage,
				size: this.otherPageSize,
				title: this.searchOtherTitle,
				type: this.searchOtherType,
				create_at: this.searchOtherTime
			};
			request({
				url: 'exam/question/otherLists',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					let _data = res.data.query;
					this.otherTkList = [];
					this.otherTkListAll = [];
					if (_data.length > 0) {
						for (let i in _data) {
							_data[i].selected = false;
						}
						this.otherTkList = _data;
						this.otherTkListAll = _data;
					} else {
						// this.$message.warning('暂无其他项目考试试题数据');
					}
					this.otherPageTotal = res.data.count;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 打开其他项目题库弹窗
		fnOpenOtherTest(){
			this.otherTkList = JSON.parse(JSON.stringify(this.otherTkListAll))
			this.showOtherTest = true
		},
		// 单个选择 其他项目题库
		fnHandleCheckedOtherTkChange(_index,_item){
			for (let i = 0; i < this.otherTkList.length; i++) {
				if (i == _index) {
					this.otherTkList[i].selected = !this.otherTkList[i].selected
				}else{
					this.otherTkList[i].selected = false
				}
			}
			let _obj = null
			for(let j in this.otherTkList){
				if(this.otherTkList[j].selected){
					_obj = this.otherTkList[j]
				}
			}
			this.otherSelect = _obj
		},
		// 保存选择的其他项目题库试题
		fnSaveOtherTest() {
			if(this.otherSelect){
				request({
					url: 'exam/question/add',
					method: 'POST',
					data: {
						question_ids: this.otherSelect.id
					}
				})
					.then(res => {
						this.$message.success(res.data);
						this.showOtherTest = false
						this.fnInit();
						this.fnGetOtherQuestionList();
					})
					.catch(err => {
						this.$message.error(err.data);
					});
			}else{
				this.$message.warning("您还没有选择试题哦！")
			}
		},
	}
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.person_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.person {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	height: 84px;
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	&.mine_search {
		width: 860px;
		height: 74px;
		margin: 0 0 10px;
	}
	.box_line {
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			.select_box {
				width: 211px;
				height: 30px;
				border-radius: 2px;
			}
		}
		.search_btn {
			width: 106px;
			height: 32px;
			background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
			background-size: 100% 100%;
			color: #ffffff;
			font-size: 14px;
			cursor: pointer;
			@include flex-box(center, center);
			span {
				margin-top: -5px;
			}
		}
		&.title{
			text-align: center;
			font-size: 34px;
			position: relative;
			display: inline-block;
			.search_btn {
				position: absolute;
				left: 0;
				top: 10px;
				&.right{
					left: 120px;
				}
			}
		}
		&.mine_line {
			height: 32px;
			width: 860px;
			.line_input {
				height: 32px;
				.input_title {
					height: 32px;
				}
				.input_box {
					height: 32px;
				}
			}
			.search_btn {
				width: 106px;
				height: 32px;
				background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
				background-size: 100% 100%;
				color: #ffffff;
				font-size: 14px;
				cursor: pointer;
				@include flex-box(center, center);
				span {
					margin-top: -5px;
				}
			}
		}
	}
}
.cont_list{
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 625px;
	position: relative;
	overflow: hidden;
	&.all_list{
		border: 1px dashed #1d4495;
	}
	.list_box {
		position: absolute;
		left: 0;
		right: -25px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.test_box {
	width: 1824px;
	min-height: 100px;
	margin: 20px 20px;
	padding: 10px 20px;
	border-radius: 5px;
	border: 1px dashed #1d4495;
	position: relative;
	.create_time{
		width: 200px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		position: absolute;
		right: 150px;
		top: -15px;
		color: #FFFFFF;
		background-color: rgba(49, 88, 128, 0.6);
	}
	.box_title {
		width: 1784px;
		min-height: 30px;
		.title_txt {
			width: 100%;
			height: 30px;
			line-height: 30px;
			font-size: 16px;
		}
		img {
			margin: 10px 0;
			width: 240px;
			height: 180px;
			border-radius: 3px;
		}
	}
	.box_answer {
		width: 1784px;
		min-height: 30px;
		.answer {
			width: 100%;
			min-height: 30px;
			.answer_txt {
				width: 100%;
				min-height: 30px;
				line-height: 30px;
				font-size: 12px;
				padding-left: 10px;
			}
			.answer_img {
				padding-left: 10px;
				@include flex-box(flex-start);
				img {
					margin: 10px 0;
					width: 200px;
					height: 160px;
					border-radius: 3px;
				}
			}
		}
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-select__caret {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown {
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>> .popper__arrow {
		border-bottom-color: rgba(77, 180, 244, 1) !important;
	}
	>>> .el-select-dropdown__item {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown__item:hover {
		color: #409eff;
	}
	>>> .el-select-dropdown__item.hover {
		color: #409eff;
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-range-input {
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-range-separator {
		color: rgba(77, 180, 244, 0.7);
	}
}
.dialog_test{
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 910px;
		height: 610px;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	.test_boxes{
		width: 870px;
		height: 490px;
		position: relative;
		overflow: hidden;
		.test_cont {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
		}
		.test_item{
			width: 870px;
			min-height: 30px;
			padding: 0 20px;
			margin: 10px 0;
			@include flex-box();
			.item_title{
				width: 100px;
				height: 30px;
				color: #9bf9fc;
				margin-right: 5px;
				background-color: rgba(49, 88, 128, 0.4);
				@include flex-box(center,center);
			}
			.item_text{
				width: 300px;
				height: 30px;
				border-top-right-radius: 1px;
				border-bottom-right-radius: 1px;
				background-color: rgba(49, 88, 128, 0.4);
				@include flex-box(flex-start, center);
				&.select{
					background: none;
				}
				&.no-bg{
					width: 600px;
					background: none;
				}
				.input_box {
					width: 300px;
					height: 30px;
					line-height: 30px;
					padding-left: 15px;
					color: rgba(77, 180, 244, 0.7);
					font-size: 12px;
					border-radius: 2px;
					outline: none;
					background: transparent;
					border: none;
					&::-webkit-input-placeholder {
						color: rgba(77, 180, 244, 0.7);
					}
					&::-moz-placeholder {
						/* Mozilla Firefox 19+ */
						color: rgba(77, 180, 244, 0.7);
					}
					&:-moz-placeholder {
						/* Mozilla Firefox 4 to 18 */
						color: rgba(77, 180, 244, 0.7);
					}
					&:-ms-input-placeholder {
						/* Internet Explorer 10-11 */
						color: rgba(77, 180, 244, 0.7);
					}
				}
				.select_box {
					width: 300px;
					height: 30px;
					border-radius: 2px;
				}
				>>> .el-input__inner {
					width: 300px;
					height: 30px;
					background-color: rgba(49, 88, 128, 0.5) !important;
					border: none !important;
					color: #439fe3 !important;
				}
				.el-select__caret {
					color: rgba(77, 180, 244, 0.7);
				}
				>>>.el-radio__label{
					color: #4DB4F4;
				}
				>>>.el-checkbox__label{
					color: #439fe3 !important;
				}
			}
			>>> .avatar-uploader {
				line-height: 100px;
				border-radius: 2px;
				img {
					width: 98px;
					height: 98px;
					border-radius: 2px;
				}
			}
			.item_imgs{
				width: 220px;
				height: 100px;
				@include flex-box(flex-start,flex-end);
				>>> .el-upload {
					width: 100px;
					height: 100px;
					line-height: 100px;
				}
				// 上传图片样式
				>>> .el-upload--picture-card {
					background-color: rgba(9, 17, 32, 0.5);
				}
			}
		}
	}
	>>>.el-dialog__body{
		padding: 0 20px;
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
}
.dialog_exam_other {
	>>> .el-dialog {
		width: 910px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid #3a74dd;
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	.exam_box {
		width: 860px;
		height: 500px;
		color: #ffffff;
		font-size: 16px;
		position: relative;
		overflow: hidden;
		.box_cont {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
		}
		.cont_list {
			width: 860px;
			height: 350px;
			color: #ffffff;
			font-size: 16px;
			border-radius: 10px;
			margin: 0;
			background-color: rgba(29, 68, 149, 0.1);
			.list_title {
				width: 860px;
				height: 48px;
				background: url(../../../assets/img/per_list_bg.png) no-repeat;
				background-size: 100% 100%;
				@include flex-box(flex-start, center);
				.title_item {
					height: 48px;
					@include flex-box(center, center);
					&:nth-child(1) {
						width: 61px;
						margin: 0 4px 0 30px;
					}
					&:nth-child(2) {
						width: 251px;
                        margin-right: 4px;
					}
					&:nth-child(3) {
						width: 101px;
                        margin-right: 4px;
					}
					&:nth-child(4) {
						width: 186px;
						margin-right: 4px;
					}
					&:nth-child(5) {
						width: 185px;
						margin-right: 30px;
					}
				}
			}
			.list_boxes_cont {
				width: 800px;
				height: 225px;
				margin-left: 30px;
				position: relative;
				overflow: hidden;
				.list_box_cont {
					position: absolute;
					left: 0;
					right: -25px;
					top: 0;
					bottom: 0;
					overflow-x: hidden;
					overflow-y: auto;
					.box_conts {
						width: 100%;
					}
					.box_line {
						width: 800px;
						height: 70px;
						margin: 5px 0 0 0px;
						border-bottom: 1px dashed #1d4495;
						@include flex-box(flex-start, center);
						&:hover {
							background-color: rgba(49, 88, 128, 0.4);
						}
						.list_item {
							height: 70px;
							text-align: center;
							@include flex-box(center, center);
							&:nth-child(1) {
								width: 61px;
								margin-right: 4px;
							}
							&:nth-child(2) {
								width: 251px;
								margin-right: 4px;
								cursor: pointer;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
							&:nth-child(3) {
								width: 101px;
								margin-right: 4px;
							}
							&:nth-child(4) {
								width: 186px;
								margin-right: 4px;
							}
							&:nth-child(5) {
								width: 185px;
								cursor: pointer;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
							div {
								@include flex-box(center, center);
								.item_btn {
									min-width: 69px;
									height: 32px;
									line-height: 32px;
									margin: 0 2px;
									font-size: 14px;
									color: #ffffff;
									border: none;
									cursor: pointer;
									padding: 0 5px;
									background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
									background-size: 100% 100%;
									@include flex-box(center, center);
									span {
										margin-top: -2px;
									}
								}
							}
							.select {
								width: 20px;
								height: 20px;
								border: 1px solid #65a6dd;
								border-radius: 2px;
								cursor: pointer;
								@include prefixCss3(transition, border-color 0.2s);
								&:hover {
									border-color: #409eff;
								}
								&.active {
									background-color: #409eff;
									border-color: #409eff;
									&::after {
										content: '';
										display: block;
										width: 100%;
										height: 100%;
										@include set-bg-img('../../../assets/images/icon-yes.png');
									}
								}
							}
						}
					}
				}
			}
		}
		.tips{
			width: 840px;
			height: 30px;
			line-height: 30px;
			color: #FF4949;
		}
		.other_page {
			width: 840px;
			height: 30px;
			>>> .el-pagination__total {
				color: #439fe3;
				font-size: 14px !important;
			}
			>>> .el-input__inner {
				background-color: rgba(49, 88, 128, 0.5) !important;
				border: none !important;
				color: #439fe3 !important;
			}
			>>> .el-pagination__jump {
				color: #439fe3;
				font-size: 14px !important;
			}
			>>> .el-select__caret {
				color: #439fe3;
			}
			>>> .el-pagination.is-background .btn-prev {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .btn-prev:disabled {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .btn-next {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .btn-next:disabled {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .el-pager li {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
				background-color: #50aaff !important;
				color: #091027;
			}
		}
	}
	.btn_line {
		@include flex-box(center, center);
	}
}
</style>



// WEBPACK FOOTER //
// src/views/TestManage/testManageDefault/index.vue